import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { BibliographyClass, CollectionFlag, Prefix, SearchType } from '@/types'
import { dateToPlainFormat } from '@/utils'

export interface LendHistory {
  lendId: number
  lendDate: string
  dueDate: string
  returnDate: string
  callNo: string
  collectionNo: string
  searchType: SearchType
  bibliographyRealId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  collectionFlag: CollectionFlag
  displayTitle: string
  sortTitle: string
  displayAuthor: string
  sortAuthor: string
  displayPublisher: string
  sortPublisher: string
  interlibraryLoanCode: SystemCode
  userId: string
  lendStatus: LendStatus
  requestedDate: string
  reserveCount: number
  revision: number
}

export const LendStatus = {
  Lending: '1',
  Returned: '2'
} as const
export type LendStatus = typeof LendStatus[keyof typeof LendStatus]

export function LendHistoryFromJSON(json: any): LendHistory {
  return {
    lendId: exists(json, 'lend_id') ? json.lend_id : 0,
    lendDate: exists(json, 'lend_date')
      ? dateToPlainFormat(json.lend_date)
      : '',
    dueDate: exists(json, 'due_date') ? dateToPlainFormat(json.due_date) : '',
    returnDate: exists(json, 'return_date')
      ? dateToPlainFormat(json.return_date)
      : '',
    callNo: exists(json, 'call_no') ? json.call_no : '',
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    searchType: exists(json, 'search_type')
      ? json.search_type
      : SearchType.Book,
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    sortTitle: exists(json, 'sort_title') ? json.sort_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    sortAuthor: exists(json, 'sort_author') ? json.sort_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    sortPublisher: exists(json, 'sort_publisher') ? json.sort_publisher : '',
    interlibraryLoanCode: exists(json, 'interlibrary_loan_code')
      ? SystemCodeFromJSON(json.interlibrary_loan_code)
      : defaultSystemCode(),
    userId: exists(json, 'user_id') ? json.user_id : '',
    lendStatus: exists(json, 'lend_status')
      ? json.lend_status
      : LendStatus.Lending,
    requestedDate: exists(json, 'requested_date')
      ? dateToPlainFormat(json.requested_date)
      : '',
    reserveCount: exists(json, 'reserve_count') ? json.reserve_count : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
